<template>
  <button
    class="btn"
    role="button"
    :class="[style, small, addClass]"
    :title="title"
    :aria-label="title"
    @click="click"
  >
    <q-icon v-if="icon != null" :icon="icon" class="mr--1"></q-icon>
    {{ title }}
  </button>
</template>

<script>
export default {
  name: "q-button",
  props: ["title", "variant", "icon", "size", "addClass"],
  methods: {
    click() {
      this.$emit("click");
    }
  },
  data() {
    return {
      style: this.variant == null ? "" : "btn--" + this.variant,
      small: this.variant == null ? "" : "btn--small"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/modules/button.scss";
</style>
